<template>
  <span>
    <el-form-item :label="label">
      <el-date-picker
        v-model="valueInput"
        type="date"
        size="mini"
        :placeholder="tlist2.placeholder">
        <!-- value-format="yyyy-MM-dd HH:mm:ss" -->
      </el-date-picker>
    </el-form-item>
  </span>
</template>

<script>
export default {
  data() {
    return {
      valueInput: this.objInput,
      tlist2: this.tprop,
    };
  },
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dateObj: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    tlist1: {
      type: Object,
    },
    objInput: {
      type: String,
    },
    tprop: {
      type: Object,
    },
  },
  watch: {
    objInput(newVal, oldVal) {
      var d = new Date(newVal);  
      newVal=d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      if (newVal !== oldVal) {
        // this.$emit("changeDateTime", newVal);
        this.valueInput = newVal;
        // //console.log('dateTime---1',newVal)
      }
    },
    valueInput(newVal, oldVal) {
      var d = new Date(newVal);  
      newVal=d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      if (newVal !== oldVal) {
          // if(this.tprop.propertyCode == '100102')
        // this.tlist2.propertyValue = newVal;
        // this.tlist2.propertyValueName = newVal;
        this.$emit("changeDateTime", newVal);
      }
    },
    tprop: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getUnit();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getUnit();
  },
  methods: {
    getUnit: function() {
      //console.log("datetime", this.tlist2);
      let b = false;
      if (this.tprop) {
        if (this.tprop.rules && this.tprop.rules.length > 0) {
          let rules = JSON.parse(this.tprop.rules);
          let unit = rules.unit;
          this.unit = unit;
          b = true;
        }
      }
      if (!b) {
        this.unit = "";
      }
    },
  },
};
</script>
